export default __webpack_public_path__ + "static/media/user.e485ad9d.svg";